module.exports = __webpack_public_path__ + "img/huzheren.f7f2600f.png";